import { ProductViewModel } from "../product-base-model";
import { SpecialServiceInventoryViewModel } from "./specialservice-inventory-view.model";

export class SpecialServiceViewModel extends ProductViewModel {
    public seasonCode: string;
    public productInventorySpecialServices: SpecialServiceInventoryViewModel[];
    public specialServiceCode: string;
}